<!--
 * @作者: kerwin
 * @公众号: 大前端私房菜
-->
<template>
  <div>
    <Particles id="tsparticles" :options="options" />

    <div class="formContainer">
      <h3>能量查询系统</h3>
      <el-form ref="loginFormRef" :model="loginForm" status-icon :rules="loginRules" label-width="80px"
        class="loginform">
        <el-form-item label="手机号" prop="username">
          <el-input v-model="loginForm.username" autocomplete="off" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="loginForm.password" type="password" autocomplete="off" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">登录</el-button>
        </el-form-item>
        <samp>说明：需要在“土豆AI”客户端首页，右上角进入资料设置密码，使用密码登录。</samp>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { ElMessage } from "element-plus";
import store from "../../store/index"; // 导入 store


const loginForm = reactive({
  username: "",
  password: "",
}); // 表单绑定的响应式对象
const loginFormRef = ref(); //表单的引用对象

const loginRules = reactive({
  username: [
    {
      required: true,
      message: "请输入手机号",
      trigger: "blur",
    },
  ],
  password: [
    {
      required: true,
      message: "请输入密码",
      trigger: "blur",
    },
  ],
});
const router = useRouter();
//提交表单函数
const submitForm = () => {
  //1. 校验表单
  loginFormRef.value.validate((valid) => {
    console.log(valid);
    if (valid) {
      console.log("提交参数", loginForm);
      axios
        .post(`/admin/loginenergy`, {
          phone: loginForm.username,
          password: loginForm.password,
        })
        .then((res) => {
          console.log("全部响应", res);
          console.log(res.data.msg);
          if (res.data.msg === "success") {
            console.log("登录成功", res.data);
            store.commit("changeUserInfo", res.data);
            store.commit("changeGetterRouter", false);
            router.push("/logdata");
          } else {
            ElMessage({
              type: "error",
              message: "登录失败,请检查用户名和密码",
            });
          }
        });
    }
  });

  //3. 设置token
  // localStorage.setItem("token", "kerwin");
};
//配置particles
const options = {
  background: {
    color: {
      value: "#2d3a4b",
    },
  },
  fpsLimit: 120,
  interactivity: {
    events: {
      onClick: {
        enable: true,
        mode: "push",
      },
      onHover: {
        enable: true,
        mode: "repulse",
      },
      resize: true,
    },
    modes: {
      bubble: {
        distance: 400,
        duration: 2,
        opacity: 0.8,
        size: 40,
      },
      push: {
        quantity: 4,
      },
      repulse: {
        distance: 200,
        duration: 0.4,
      },
    },
  },
  particles: {
    color: {
      value: "#ffffff",
    },
    links: {
      color: "#ffffff",
      distance: 150,
      enable: true,
      opacity: 0.5,
      width: 1,
    },
    collisions: {
      enable: true,
    },
    move: {
      direction: "none",
      enable: true,
      outMode: "bounce",
      random: false,
      speed: 1,
      straight: false,
    },
    number: {
      density: {
        enable: true,
        area: 800,
      },
      value: 80,
    },
    opacity: {
      value: 0.5,
    },
    shape: {
      type: "circle",
    },
    size: {
      random: true,
      value: 5,
    },
  },
  detectRetina: true,
};
</script>

<style lang="scss" scoped>
.formContainer {
  width: 500px;
  height: 300px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba($color: #000000, $alpha: 0.5);
  color: white;
  text-align: center;
  padding: 20px;

  h3 {
    font-size: 30px;
  }

  .loginform {
    margin-top: 20px;
  }
}

::v-deep .el-form-item__label {
  color: white;
}
</style>
